import { gql } from '@apollo/client';

export const WAITING_ROOM_BOARD_QUERY = gql`
  query WaitingRoomBoard {
    waitingRoomBoard {
      consulting_room_id
      consulting_room_name
      display_order
      zone_type
      occupancy_status
      sale_order_id
      veterinarian_id
      veterinarian_name
      pet_name
      pet_species
    }
  }
`;

export const MEDICAL_QUEUE_BOARD_QUERY = gql`
  query DisplayMedicalQueueBoard {
    medicalQueueBoard {
      sale_order_id
      customer_id
      pet_id
      customer_name
      pet_name
      pet_species
      pet_age_label
      current_weight_grams
      cashier_initial_notes
      primary_item_label
      consulting_room_id
      consulting_room_name
      queued_at
    }
  }
`;

export const WAITING_ROOM_DISPLAY_SETTINGS_QUERY = gql`
  query WaitingRoomDisplaySettings {
    waitingRoomDisplaySettings {
      youtube_playlist_id
      is_configured
      refresh_token
    }
  }
`;
